export const Colors = {
  Alto: '#DADADA',
  Cascade: '#87ab9b',
  Concrete: '#F2F2F2',
  Contessa: '#CA7B7B',
  LimedSpruce: '#38424B',
  Mercury: '#E3E3E3',
  OldRose: '#BA8077',
  PurpleMountainsMajesty: '#8877BA',
  Scorpion: '#606060',
  Whisper: '#F5F4F9',
  White: '#ffffff',
  Black: '#000000',
}
